import script from "./GestionarSeguridadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionarSeguridadModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__